export default __webpack_public_path__ + "static/media/new-claim.7cc07c39.svg";